import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

/** Full-page skeleton shown while the listing detail payload loads. */
export const ListingDetailSkeleton: React.FC = () => (
  <div className="min-h-screen bg-gray-50">
    <div className="mx-auto max-w-6xl space-y-6 p-6">
      {/* Back link */}
      <Skeleton className="h-5 w-32" />

      {/* Hero */}
      <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div className="flex items-start justify-between gap-4 bg-gradient-to-br from-indigo-500 via-indigo-600 to-purple-600 px-6 py-8">
          <div className="space-y-3">
            <Skeleton className="h-6 w-24 rounded-full bg-white/30" />
            <Skeleton className="h-7 w-64 bg-white/30" />
            <Skeleton className="h-4 w-40 bg-white/20" />
          </div>
          <Skeleton className="h-14 w-28 rounded-xl bg-white/20" />
        </div>
        <div className="grid grid-cols-2 gap-4 px-6 py-5 sm:grid-cols-3 lg:grid-cols-5">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="space-y-1.5">
              <Skeleton className="h-3 w-12" />
              <Skeleton className="h-4 w-20" />
            </div>
          ))}
        </div>
      </div>

      {/* Moderation bar */}
      <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
        <Skeleton className="mb-3 h-4 w-28" />
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 7 }).map((_, i) => (
            <Skeleton key={i} className="h-8 w-24 rounded-md" />
          ))}
        </div>
        <div className="mt-4 flex flex-wrap gap-2 border-t border-gray-100 pt-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-7 w-24 rounded-full" />
          ))}
        </div>
      </div>

      {/* Tabs card */}
      <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div className="flex gap-4 border-b border-gray-100 px-4 py-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-5 w-20" />
          ))}
        </div>
        <div className="space-y-4 p-6">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-32 w-full" />
        </div>
      </div>
    </div>
  </div>
);
